import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space12,
    background: theme.colors.background4,
    padding: theme.spacing.space12,
    borderRadius: theme.radius.sSmall + theme.radius.small,
  },
}));
